export default __webpack_public_path__ + "static/media/leadBundle1.53b51dbf.svg";